import * as Yup from 'yup';

export const signUpResentSchema = Yup.object().shape({
    email: Yup.string().email().max(128).required(),
});
